import { createReducer, on } from '@ngrx/store';

import { DocumentsActions } from './documents.actions';
import { DocumentsState } from './documents.state';

export const initDocumentsState: DocumentsState = {
  documents: [],
  documentsUpdated: [],
  xotaMode: null,
  xotaLoading: false,
};
export const documentsReducer = createReducer(
  initDocumentsState,

  on(
    DocumentsActions.getDocuments,
    (): DocumentsState => ({
      ...initDocumentsState,
    })
  ),

  on(
    DocumentsActions.getDocumentsSuccess,
    DocumentsActions.dataUsageAgreementDocument.success,
    (state, { documents }): DocumentsState => ({
      ...state,
      documents,
    })
  ),

  on(
    DocumentsActions.getUpdatedDocuments,
    (state): DocumentsState => ({
      ...state,
    })
  ),

  on(
    DocumentsActions.getUpdatedDocumentsSuccess,
    (state, { updatedDocuments }): DocumentsState => ({
      ...state,
      documentsUpdated: updatedDocuments,
    })
  ),

  on(
    DocumentsActions.agreeOnDocuments,
    (state): DocumentsState => ({
      ...state,
    })
  ),

  on(
    DocumentsActions.getXotaAgreementStatus,
    (state): DocumentsState => ({
      ...state,
      xotaLoading: true,
    })
  ),

  on(
    DocumentsActions.getXotaAgreementStatusSuccess,
    (state, { xotaMode }): DocumentsState => ({
      ...state,
      xotaMode: xotaMode,
      xotaLoading: false,
    })
  ),

  on(
    DocumentsActions.getXotaAgreementStatusError,
    (state): DocumentsState => ({
      ...state,
      xotaMode: null,
      xotaLoading: false,
    })
  )
);
